import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class RecurrenceQueries {

  listRecurrences(): DocumentNode {
    return gql`
    query listRecurrences($where: RecurrenceWhereInput, $orderBy: RecurrenceOrderByInput, $limit: Int, $offset: Int) {
      recurrences(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        items {
          id
          type
          message
          archived
          createdAt
          repeat {
            from
            every
            interval
            weekday
            dayOfMonth
            skipWeekend
            until
          }
          iteration
          maintenanceType {
            name
          }
          segment {
            name
          }
          location {
            name
          }
          company {
            name
            avatarUrl
            fieldAccountId
          }
          equipments {
            id
          }
          locationSectors {
            id
          }
          locationEnvironments {
            id
          }
        }
      }
    }
  `;
  }

  getRecurrenceById(): DocumentNode {
    return gql`
    query queryRecurrence($id: ID!) {
      recurrence(id: $id) {
        id
        type
        message
        archived
        createdAt
        iteration
        locked
        source
        repeat {
          from
          every
          interval
          weekday
          dayOfMonth
          skipWeekend
          until
        }
        maintenanceType {
          id
          name
          type
          archived
        }
        segment {
          id
          name
          archived
        }
        location {
          id
          name
          archived
          address {
            formattedAddress
          }
        }
        company {
          id
          name
          avatarUrl
          fieldAccountId
          archived
        }
        locationSectors {
          id
          name
          description
          archived
        }
        locationEnvironments {
          id
          name
          description
          archived
          locationSector {
            id
            name
          }
        }
        equipments {
          id
          name
          number
          notes
          archived
          imageUrl
          locationSector {
            id
            name
          }
          locationEnvironment {
            id
            name
          }
        }
        logs {
          id
          createdAt
          updatedBy {
            id
            name
          }
          clientApplicationName
          snapshot {
            id
            message
            location {
              id
              name
            }
            equipments {
              id
              name
              number
              archived
              imageUrl
              locationSector {
                id
                name
                archived
              }
              locationEnvironment {
                id
                name
                archived
              }
            }
            locationSectors {
              id
              name
              archived
            }
            locationEnvironments {
              id
              name
              archived
              locationSector {
                id
                name
                archived
              }
            }
            archived
          }
        }
      }
    }
  `;

  }


  getFiltersData(): DocumentNode {
    return gql`
    query getFiltersData {
      locations: locationsNew(orderBy: { column: name, direction: asc }, limit: 100) {
        items {
          id
          name
        }
      }
      segments {
        items {
          id
          name
        }
      }
    }
    `;
  }

  listOccurrences(): DocumentNode {
    return gql`
    query listOccurrences(
      $where: OccurrenceWhereInput!
      $orderBy: OccurrenceOrderByInput
      $limit: Int
      $offset: Int
    ) {
      occurrences(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        items {
          id
          iteration
          scheduledAt
          scheduledDate
          createdAt
          maintenance {
            id
            status
            number
            company {
              name
            }
          }
        }
      }
    }
    `;
  }

  createRecurrence(): DocumentNode {
    return gql`
    mutation createRecurrence($input: RecurrenceCreateInput!) {
      createRecurrence(input: $input) {
        id
      }
    }`;
  }

  updateRecurrence(): DocumentNode {
    return gql`
    mutation updateRecurrence($id: ID!, $input: RecurrenceUpdateInput!) {
      updateRecurrence(id: $id, input: $input) {
        id
      }
    }`;
  }
}
